import React from 'react'
import http from '../services/http/interceptors'
import { useNavigate } from 'react-router-dom'
import { ethers } from "ethers"
import { formatAddress } from "../utils"
import "../senshi.css"

export const Login = () => {
  const navigateTo = useNavigate()
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const [connectedAddress, setConnectedAddress] = React.useState('')
  const [referrer, setReferrer] = React.useState('')
  const [provider, setProvider] = React.useState('')
  const [signer, setSigner] = React.useState('')
  const [username, setUsername] = React.useState('')
  const [status, setStatus] = React.useState('')
  const [amount, setAmount] = React.useState('')


  const connectWallet = async () => {
    try {
      const { ethereum } = window;

        if (!ethereum) {
            alert("Please install MetaMask!")
            return
        }

        const accounts = await ethereum.request({
            method: "eth_requestAccounts",
        });

        // console.log("Connected", accounts[0])

        const _provider = new ethers.providers.Web3Provider(ethereum)
        const _signer = _provider.getSigner()
        
        setConnectedAddress(accounts[0])
        setProvider(_provider)
        setSigner(_signer)



  var abi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}];

  const senshiContract = new ethers.Contract('0x6862e42f7e527a068ed98670fd637783bb022859', abi, _provider);

      console.log('senshiContract', senshiContract)

console.log('connectedAddress', accounts[0])

const _amount = await senshiContract.balanceOf(accounts[0]);

console.log("amount", _amount.toNumber())

if (_amount.toNumber() === 0) {
  setAmount(0)
}

      } catch (error) {
        console.log(error)
      }
  }

  const handleAccountChange = async () => {
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });

    setConnectedAddress(accounts[0])
    // console.log('Account Changed', accounts[0])
  }

  React.useEffect(() => {
    connectWallet()

    // console.log("connectedAddress !== ''", connectedAddress !== '')

    if (connectedAddress !== '') {
      fetch('/validateAddress', { address: connectedAddress })
      .then((response) => response.json())
      .then((data) => console.log(data));
    }

  }, []);

  React.useEffect(() => {
    window.ethereum.on("accountsChanged", handleAccountChange)
    return () => {
      window.ethereum.removeListener("accountsChanged", handleAccountChange)
    }
  })

  React.useEffect(() => {
    getReferrer()
  }, [])

  const getReferrer = async () => {
    let ref = ''
    let referralFromLocalStorage = localStorage.getItem('ref')
    let referralFromURL = params['ref']

    if (referralFromLocalStorage) {
      ref = referralFromLocalStorage
    } else {
      ref = referralFromURL
      localStorage.setItem('ref', referralFromURL);
    }

    setReferrer(ref)
  }

  const login = async () => {

    let sign = await signer.signMessage(`Sign in to Senshi with ${connectedAddress}`)

    const send = await http.post('/dashboard', {
      params: {
        address: connectedAddress,
        referral: referrer,
        sign
      }
    })

    if (send.status === 200) navigateTo('/preview')
  }

  return (
    <div className="login">
      <div id="senshi-loading">
        <img src={'./sachi2.png'} />
          <div id="senshi-loading-container">   
            <ul>
              <li>
                <h4>
                  {
                    connectedAddress === '' 
                    ? 'Please connect your wallet'
                    : amount === 0 ? 'You do not have any $SENSHI' : <span className="darkGreen"><a onClick={login} style={{cursor: 'pointer', color: 'white'}}>Click here to confirm you're {formatAddress(connectedAddress)}</a></span>
                  }
                </h4>
              </li>
            </ul>  
          </div>
      </div>
    </div>
  )
}
